import { render, staticRenderFns } from "./settings-employees-popup.vue?vue&type=template&id=0ffb089c&scoped=true&"
import script from "./settings-employees-popup.vue?vue&type=script&lang=js&"
export * from "./settings-employees-popup.vue?vue&type=script&lang=js&"
import style0 from "./settings-employees-popup.vue?vue&type=style&index=0&id=0ffb089c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb089c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ffb089c')) {
      api.createRecord('0ffb089c', component.options)
    } else {
      api.reload('0ffb089c', component.options)
    }
    module.hot.accept("./settings-employees-popup.vue?vue&type=template&id=0ffb089c&scoped=true&", function () {
      api.rerender('0ffb089c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/settings-employees-popup.vue"
export default component.exports